// Material
import { useMemo } from 'react'
import { Divider } from '@mui/material'
import { PrivacyType } from '@weblite/ts-action/user-policy'
// Common
import { MenuIcon } from '$common/icons/menu'
import { AddUserIcon } from '$common/icons'
import {
  UserListItemSkeleton,
  UserListItemWithStatus,
} from '$common/user-list-item'
import { EmptyStateList } from '$common/empty-state-list'
import { withSearchableListPage } from '$common/searchable-list-page'
// Localization
import { t } from '$i18n'
import {
  closePrivacyExceptionUsers,
  openAddPrivacyExceptionUsers,
  openUserProfile,
} from '$logic/router'
import { showDeleteExceptionUserMenu } from '$comp/modals/menus/delete-exception-user-menu'
import {
  usePrivacyExceptionUsers,
  useSearchedPrivacyExceptionUsers,
} from '$logic/user-policy/react-hook'

const ListItem = ({
  id,
  privacyType,
}: {
  id: string
  privacyType: PrivacyType
}) => (
  <>
    <UserListItemWithStatus
      userId={id}
      hasDivider={false}
      onClick={() => openUserProfile(id)}
      SecondaryActionIcon={MenuIcon}
      onSecondaryActionIconClick={() =>
        showDeleteExceptionUserMenu({ userId: id, privacyType })
      }
    />
    <Divider variant="inset" />
  </>
)

export function PrivacyExceptionUsers({
  privacyType,
  exceptionType,
}: {
  privacyType: PrivacyType
  exceptionType: 'never' | 'always'
}) {
  const Page = useMemo(
    () =>
      withSearchableListPage<
        { id: string },
        null,
        { query: string; fetchedItems: { id: string }[] }
      >({
        appBarTitle: t(`settings.privacy.exception.${exceptionType}`),
        ListItem: item => <ListItem id={item.id} privacyType={privacyType} />,
        SkeletonItem: UserListItemSkeleton,
        EmptyStateComponent: () => <EmptyStateList />,
        fetchHook: () => usePrivacyExceptionUsers(privacyType, exceptionType),
        searchHook: useSearchedPrivacyExceptionUsers,
        subHeaderText: t('settings.privacy.exception.exceptions'),
        actionButtons: [
          {
            text: t('settings.privacy.exception.addUsers'),
            icon: <AddUserIcon color="secondary" />,
            onClick: () =>
              openAddPrivacyExceptionUsers(privacyType, exceptionType),
          },
        ],
        onBack: closePrivacyExceptionUsers,
      }),
    [],
  )

  return (
    <Page
      fetchHookParams={null}
      getSearchHookParams={(query, fetchedItems) => ({ query, fetchedItems })}
    />
  )
}
